export const base64ToBytes = (base64) => {
  const binary = atob(base64)
  const buffer = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    buffer[i] = binary.charCodeAt(i)
  }
  return buffer
}

export const bytesToBase64 = (bytes) => {
  const intArray = new Uint8Array(bytes)
  const reducedArray = intArray.reduce((data, byte) => data + String.fromCharCode(byte), '')
  return btoa(reducedArray)
}



// WEBPACK FOOTER //
// ./src/libs/utils/functions/base64.js